import { useRef, useCallback, useState } from 'react'
import { useGLTF, Outlines } from '@react-three/drei'
import useCameraStore from './store'
import { playAudioOnly } from './AudioButton'
import modelUrl from './assets/models/ContactBooth-transformed.glb'

export function InteractiveContactBoothOptimized(props) {
  const meshRef = useRef()
  const [hovered, setHovered] = useState(false)
  const handleElementClick = useCameraStore((state) => state.handleElementClick)
  const setHoveredElement = useCameraStore((state) => state.setHoveredElement)
  const lastClickedElement = useCameraStore((state) => state.lastClickedElement)
  const isElementFocused = useCameraStore((state) => state.isElementFocused)
  const clickTimeoutRef = useRef()
  const hoverTimeoutRef = useRef()
  const { nodes, materials } = useGLTF(modelUrl)

  // Check if booth is currently selected
  const isSelected = lastClickedElement === 'contact-booth' && isElementFocused

  const handleClick = useCallback((e) => {
    // Prevent event bubbling and multiple triggers
    e.stopPropagation()

    // Debounce clicks to prevent double-triggering
    if (clickTimeoutRef.current) return

    clickTimeoutRef.current = setTimeout(() => {
      clickTimeoutRef.current = null
    }, 300)

    // Play audio as an easter egg (only starts, never stops)
    playAudioOnly()

    // Use camera preset for booth
    handleElementClick('contact-booth')
  }, [handleElementClick])

  const handlePointerOver = useCallback((e) => {
    e.stopPropagation()
    // Clear any pending hide timeout
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current)
      hoverTimeoutRef.current = null
    }
    if (!hovered) {
      setHovered(true)
      setHoveredElement('contact-booth')
      document.body.style.cursor = 'pointer'
    }
  }, [hovered, setHoveredElement])

  const handlePointerOut = useCallback((e) => {
    e.stopPropagation()
    // Add a small delay before hiding to prevent flickering at edges
    hoverTimeoutRef.current = setTimeout(() => {
      setHovered(false)
      setHoveredElement(null)
      document.body.style.cursor = 'auto'
      hoverTimeoutRef.current = null
    }, 100)
  }, [setHoveredElement])

  // Simplified outline - only show when needed
  const showOutline = hovered || isSelected

  return (
    <group
      ref={meshRef}
      {...props}
      dispose={null}
      onClick={handleClick}
      onPointerOver={handlePointerOver}
      onPointerOut={handlePointerOut}
    >
      <mesh
        geometry={nodes['tripo_node_52bbd55e-454f-419d-b04d-5773f7482032'].geometry}
        material={materials['tripo_material_52bbd55e-454f-419d-b04d-5773f7482032']}
      >
        {showOutline && (
          <Outlines
            thickness={0.8}
            color="#35c19f"
            angle={0}
          />
        )}
      </mesh>
    </group>
  )
}

useGLTF.preload(modelUrl)